import {Children} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import {Typography} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    display: "flex",
    flexDirection: "column"
  },
  header: {
    padding: 0,
    justifyContent: 'space-between'
  },
  title: {
    textAlign: 'center',
    padding: theme.spacing(3, 3, 0),
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  content: {
    padding: theme.spacing(3),
  },
  footer: {
    paddingTop: 70,
    marginTop: "auto"
  }
}));

export default function Header({children, title, ...props}) {
  const classes = useStyles();
  let appBar = '';
  let content = '';
  let footer = '';

  Children.forEach(children, (child) => {
    const element = {
      [Header.AppBar.type]() {
        appBar = child;
      },
      [Header.Content.type]() {
        content = child;
      },
      [Header.Footer.type]() {
        footer = child;
      }
    }[child.type.type];

    if (!element) {
      throw new Error('Unknown child type for Header');
    }
    element();
  });

  return (
    <div className={classes.root}>
      <AppBar position="static" {...props}>
        <Toolbar className={classes.header}>{appBar}</Toolbar>
      </AppBar>
      <div className={classes.title}>
        <Typography variant="h4" component="h1">
          {title}
        </Typography>
      </div>
      <main className={classes.content}>{content}</main>
      <footer className={classes.footer}>{footer}</footer>
    </div>
  );
}
